import {Component, Input} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {ValidationService} from '@core/services';

export enum UpdateTrigger {
  Touched,
  Dirty
}

@Component({
  selector: 'app-validation-message',
  styles: ['span { display: block; padding: 2px 6px; }'],
  templateUrl: './validation-message.component.html'
})
export class ValidationMessageComponent {
  @Input() control: UntypedFormControl;
  // Setting the current behavior of validations to the default
  @Input() updateOn: UpdateTrigger = UpdateTrigger.Touched;
  @Input() ignoreDirtyValidationPattern: string;

  constructor() {
  }

  get errorMessage() {
    // tslint:disable-next-line:forin
    for (const propertyName in this.control.errors) {
      let shouldUpdate = false;

      if (this.updateOn === UpdateTrigger.Touched) {
        shouldUpdate = this.control.touched;
      } else if (this.updateOn === UpdateTrigger.Dirty) {
        shouldUpdate = this.control.dirty;
        if (shouldUpdate && !this.control.touched && this.ignoreDirtyValidationPattern) {
          const regEx = new RegExp(this.ignoreDirtyValidationPattern);
          shouldUpdate = !regEx.test(this.control.value);
        }
      }

      if (this.control.errors.hasOwnProperty(propertyName) && shouldUpdate) {
        return ValidationService.getValidatorErrorMessage(propertyName, this.control.errors[propertyName]);
      }
    }
    return null;
  }
}
